import React from 'react';
import BlogClassicData from '../../data/blog/BlogClassic.json';
import BlogItem from '../../components/Blog/BlogItem';
import SectionTitle from '../../components/SectionTitles/SectionTitle';

const HomeBlog = ({ title, subTitle }) => {

    const SectionBgColor = "section section-padding-t90-b100";
    return (
        <div className={`section section-padding-t90-b100 ${SectionBgColor}`} style={{marginTop: '50px'}}>
            <div className="container">
                <SectionTitle
                    title={title}
                    subTitle={subTitle}
                />

                <div className="row row-cols-lg-3 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n6">
                        {BlogClassicData && BlogClassicData.slice(0, 3).map((single, key) => {
                            return(
                                <div key={key} className="col mb-6" data-aos="fade-up">
                                    <BlogItem data={single} key={key} />
                                </div>
                            ); 
                        })}
                </div>
            </div>
        </div>
    )
}

export default HomeBlog;
